// extracted by mini-css-extract-plugin
export default {"labsContainer":"PrescriptionRenewalsViewResults_labsContainer__-AhjP"};